import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import {
  api,
  enriquecerUsuarioComMe,
  registrarInterceptorTenant,
  syncTenantKey,
} from "roboflex-thalamus-request-handler";
import "./assets/css/thalamus.css";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

api.defaults.baseURL = process.env.VUE_APP_ROOT_API;

/** Troca de tenant → reload completo (request-handler); não usa eventos in-app. */
registrarInterceptorTenant();

async function bootstrap() {
  try {
    await enriquecerUsuarioComMe();
  } catch {
    // claims / offline — segue com o que houver no SSO
  }
  syncTenantKey();

  const app = createApp(App);
  app.config.globalProperties.$moduleName = "Orçamento";
  app.use(router);
  app.use(Toast);
  app.mount("#app");
}

bootstrap();
